export type SeverityTier = 'critical' | 'notice';

export type ReportReason =
  | 'CHILD_SAFETY'
  | 'SEXUAL_CONTENT'
  | 'REGULATED_GOODS'
  | 'HARASSMENT'
  | 'HATE_SPEECH'
  | 'SELF_HARM'
  | 'UNLABELED_AI'
  | 'IMPERSONATION'
  | 'SCAM_FRAUD'
  | 'SPAM'
  | 'IP_THEFT'
  | 'UNDISCLOSED_ADS'
  | 'GRAPHIC_CONTENT'
  | 'OFF_TOPIC'
  | 'SPOILERS';

const TIER_MAP: Record<ReportReason, SeverityTier> = {
  CHILD_SAFETY: 'critical',
  SEXUAL_CONTENT: 'critical',
  REGULATED_GOODS: 'critical',
  HARASSMENT: 'notice',
  HATE_SPEECH: 'notice',
  SELF_HARM: 'notice',
  UNLABELED_AI: 'notice',
  IMPERSONATION: 'notice',
  SCAM_FRAUD: 'notice',
  SPAM: 'notice',
  IP_THEFT: 'notice',
  UNDISCLOSED_ADS: 'notice',
  GRAPHIC_CONTENT: 'notice',
  OFF_TOPIC: 'notice',
  SPOILERS: 'notice',
};

export function reasonToTier(reason: string): SeverityTier {
  return TIER_MAP[reason as ReportReason] ?? 'notice';
}
